(() => {
  const NW = window.NW || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* ---------- flags ---------- */
  $$('.flag[data-iso]').forEach(el => {
    const iso = (el.dataset.iso || '').toLowerCase();
    if (!/^[a-z]{2}$/.test(iso)) return;
    const img = document.createElement('img');
    img.src = `https://flagcdn.com/w40/${iso}.png`; img.alt = el.title || iso.toUpperCase();
    img.width = 20; img.height = 14; img.loading = 'lazy'; img.className = 'flag__img';
    el.textContent = ''; el.appendChild(img);
  });

  /* ---------- money ---------- */
  function money(cents) {
    const fmt = NW.moneyFormat || '{{amount}}';
    const n = (cents || 0) / 100;
    const f = (dec, th, ds) => {
      const parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.join(ds);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: f(2, ',', '.'),
      amount_no_decimals: f(0, ',', '.'),
      amount_with_comma_separator: f(2, '.', ','),
      amount_no_decimals_with_comma_separator: f(0, '.', ','),
      amount_with_space_separator: f(2, ' ', ','),
      amount_with_period_and_space_separator: f(2, ' ', '.'),
      amount_with_apostrophe_separator: f(2, "'", '.')
    }[k] ?? f(2, ',', '.')));
  }
  NW.money = money;

  /* ---------- protection ---------- */
  if (NW.protect) {
    document.documentElement.classList.add('nw-protect');
    const editable = t => t && (t.closest('input,textarea,[contenteditable]'));
    document.addEventListener('contextmenu', e => { if (!editable(e.target)) e.preventDefault(); });
    document.addEventListener('dragstart', e => { if (e.target.tagName === 'IMG' || e.target.tagName === 'VIDEO') e.preventDefault(); });
    document.addEventListener('copy', e => { if (!editable(e.target)) e.preventDefault(); });
    document.addEventListener('keydown', e => {
      const k = (e.key || '').toLowerCase();
      if ((e.ctrlKey || e.metaKey) && ['s', 'u', 'p'].includes(k)) e.preventDefault();
      if ((e.ctrlKey || e.metaKey) && k === 'c' && !editable(e.target)) e.preventDefault();
      if (k === 'f12' || ((e.ctrlKey || e.metaKey) && e.shiftKey && ['i', 'j', 'c'].includes(k))) e.preventDefault();
    });
    $$('video').forEach(v => v.setAttribute('controlsList', 'nodownload'));
  }

  /* ---------- double-click / double-submit protection ---------- */
  document.addEventListener('submit', e => {
    const f = e.target;
    if (f.dataset.submitted) { e.preventDefault(); return; }
    const b = f.querySelector('[data-once]');
    if (b) { f.dataset.submitted = '1'; setTimeout(() => { b.classList.add('is-loading'); }, 0); setTimeout(() => { delete f.dataset.submitted; b.classList.remove('is-loading'); }, 8000); }
  }, true);
  const locks = new WeakSet();
  async function once(btn, fn) {
    if (!btn || locks.has(btn)) return;
    locks.add(btn); btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
    try { return await fn(); } finally { setTimeout(() => { locks.delete(btn); btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }, 600); }
  }

  /* ---------- cart api ---------- */
  const post = (url, body) => fetch(url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(async r => { const j = await r.json(); if (!r.ok) throw new Error(j.description || j.message || 'Error'); return j; });
  const getCart = () => fetch(NW.cartUrl + '.js', { headers: { Accept: 'application/json' } }).then(r => r.json());

  /* ---------- drawer ---------- */
  const drawer = $('[data-drawer]');
  function openCart() { if (!drawer) { location.href = NW.cartUrl; return; } drawer.hidden = false; document.body.style.overflow = 'hidden'; renderCart(); }
  function closeCart() { if (drawer) { drawer.hidden = true; document.body.style.overflow = ''; } }
  document.addEventListener('click', e => {
    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-close-cart]')) closeCart();
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeCart(); $$('[data-calc]').forEach(m => m.hidden = true); } });

  async function renderCart(cart) {
    cart = cart || await getCart();
    $$('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    if (!drawer) return;
    const box = $('[data-drawer-items]', drawer);
    box.innerHTML = cart.items.length ? cart.items.map((it, i) => `
      <div class="dl">
        ${it.image ? `<img src="${it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')}" alt="">` : '<span></span>'}
        <div><strong>${it.product_title}</strong><small>${it.variant_title || ''}</small>
          ${(it.line_level_discount_allocations || []).map(d => `<small class="accent">${d.discount_application.title} −${money(d.amount)}</small>`).join('')}
          <div class="dl__q"><button type="button" data-line="${i + 1}" data-q="${it.quantity - 1}">−</button><span>${it.quantity}</span><button type="button" data-line="${i + 1}" data-q="${it.quantity + 1}">+</button></div>
        </div>
        <strong>${money(it.final_line_price)}</strong>
      </div>`).join('') : `<p class="muted">—</p>`;
    $$('[data-drawer-total]', drawer).forEach(el => el.textContent = money(cart.total_price));
    const inCart = new Set(cart.items.map(i => String(i.variant_id)));
    $$('[data-bump-variant]', drawer).forEach(el => { el.hidden = inCart.has(el.dataset.bumpVariant); });
    const bar = $('[data-ship-bar]', drawer);
    if (bar) {
      const th = +bar.dataset.threshold, pct = Math.min(100, cart.total_price / th * 100);
      $('[data-ship-fill]', bar).style.width = pct + '%';
      $('[data-ship-text]', bar).textContent = pct >= 100 ? '✓' : money(th - cart.total_price);
    }
  }
  drawer && drawer.addEventListener('click', e => {
    const q = e.target.closest('[data-line]');
    if (q) once(q, async () => renderCart(await post(NW.cartChangeUrl, { line: +q.dataset.line, quantity: Math.max(0, +q.dataset.q) })));
    const b = e.target.closest('[data-bump-add]');
    if (b) once(b, async () => { await post(NW.cartAddUrl, { items: [{ id: +b.dataset.bumpAdd, quantity: 1 }] }); renderCart(); });
  });

  /* ---------- gallery ---------- */
  $$('[data-gallery]').forEach(g => {
    const slides = $$('.gal__slide', g), thumbs = $$('.gal__thumb', g);
    let cur = 0;
    const go = i => {
      if (!slides.length) return;
      cur = (i + slides.length) % slides.length;
      slides.forEach(s => { const on = +s.dataset.index === cur; s.classList.toggle('is-active', on); const v = $('video', s); if (v && !on) v.pause(); });
      thumbs.forEach(t => t.classList.toggle('is-active', +t.dataset.go === cur));
      const t = thumbs.find(t => +t.dataset.go === cur); t && t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    };
    g.goTo = go;
    g.addEventListener('click', e => {
      if (e.target.closest('[data-prev]')) go(cur - 1);
      if (e.target.closest('[data-next]')) go(cur + 1);
      const t = e.target.closest('[data-go]'); if (t) go(+t.dataset.go);
    });
    let x0 = null;
    g.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
    g.addEventListener('touchend', e => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1)); x0 = null; });
  });

  /* ---------- product landing ---------- */
  $$('[data-product-landing]').forEach(root => {
    const form = $('product-form-nw', root);
    const product = JSON.parse($('[data-product]', form).textContent);
    const packs = JSON.parse($('[data-packs]', form).textContent || '[]').filter(p => p.qty > 0);
    const swatches = JSON.parse($('[data-swatches]', form).textContent || '{}');
    const gallery = $('[data-gallery]', root);
    const qtyIn = $('[data-qty]', form);
    const addBtn = $('[data-add]', form), buyBtn = $('[data-buy-now]', form), msg = $('[data-msg]', form);
    const state = { color: null, size: null, qty: 1 };

    const findVariant = (c, s) => product.variants.find(v => v.option1 === c && v.option2 === s);
    const offFor = q => packs.filter(p => q >= p.qty).reduce((m, p) => Math.max(m, p.off), 0);
    const variant = () => state.color && state.size ? findVariant(state.color, state.size) : null;

    $$('.sw__b', form).forEach(b => {
      const sw = swatches[b.dataset.color];
      if (sw) b.style.setProperty('--sw', sw.hex);
      b.addEventListener('click', () => { state.color = b.dataset.color; if (sw && gallery && gallery.goTo) gallery.goTo(sw.img); update(); });
    });
    $$('.sz__b', form).forEach(b => b.addEventListener('click', () => {
      if (b.classList.contains('is-out')) return;
      state.size = b.dataset.size; update();
    }));
    const packsBox = $('[data-packs-list]', form);
    function renderPacks(v) {
      if (!packsBox) return;
      const unit = v ? v.price : product.price_min;
      const best = packs.length > 2 ? packs[Math.floor(packs.length / 2)].qty : null;
      packsBox.innerHTML = packs.map(p => {
        const full = unit * p.qty, net = Math.round(full * (1 - p.off / 100));
        const label = p.qty === 1 ? `1 ${NW.t.panel}` : `${p.qty} ${NW.t.panels}`;
        return `<div class="pk${state.qty === p.qty ? ' is-active' : ''}" data-pack="${p.qty}" role="radio" tabindex="0" aria-checked="${state.qty === p.qty}">
          ${p.qty === best ? '<span class="pk__badge">★ TOP</span>' : ''}
          <span class="pk__r"></span>
          <span class="pk__t"><strong>${label}</strong>${p.off ? `<small>−${p.off}%</small>` : ''}</span>
          <span class="pk__p"><strong>${money(net)}</strong>${p.off ? `<s>${money(full)}</s>` : ''}</span></div>`;
      }).join('');
    }
    packsBox && packsBox.addEventListener('click', e => { const p = e.target.closest('[data-pack]'); if (p) { state.qty = +p.dataset.pack; update(); } });
    packsBox && packsBox.addEventListener('keydown', e => { if ((e.key === 'Enter' || e.key === ' ') && e.target.dataset.pack) { e.preventDefault(); state.qty = +e.target.dataset.pack; update(); } });
    $('[data-qty-minus]', form).addEventListener('click', () => { state.qty = Math.max(1, state.qty - 1); update(); });
    $('[data-qty-plus]', form).addEventListener('click', () => { state.qty = Math.min(999, state.qty + 1); update(); });
    qtyIn.addEventListener('change', () => { state.qty = Math.max(1, Math.min(999, parseInt(qtyIn.value, 10) || 1)); update(); });

    let update = function () {
      const refColor = state.color || product.options[0] && product.variants[0].option1;
      $$('.sw__b', form).forEach(b => b.setAttribute('aria-checked', String(b.dataset.color === state.color)));
      $('[data-color-label]', form).textContent = state.color || NW.t.choose;
      $$('.sz__b', form).forEach(b => {
        const v = findVariant(refColor, b.dataset.size);
        const out = !v || !v.available;
        b.classList.toggle('is-out', out);
        b.classList.toggle('is-active', b.dataset.size === state.size);
        b.querySelector('[data-size-price]').textContent = out ? NW.t.soldout : `${money(v.price)} / ${NW.t.unit}`;
        if (out && state.size === b.dataset.size) state.size = null;
      });
      $('[data-size-label]', form).textContent = state.size || NW.t.choose;
      const v = variant();
      qtyIn.value = state.qty;
      renderPacks(v);
      const ok = v && v.available;
      addBtn.disabled = buyBtn.disabled = !ok;
      const off = offFor(state.qty);
      $('[data-total]', form).textContent = v ? money(Math.round(v.price * state.qty * (1 - off / 100))) : '';
    };

    async function add() {
      const v = variant(); if (!v) return;
      await post(NW.cartAddUrl, { items: [{ id: v.id, quantity: state.qty }] });
      msg.textContent = NW.t.added;
    }
    addBtn.addEventListener('click', () => once(addBtn, async () => { try { await add(); openCart(); } catch (e) { msg.textContent = e.message; } }));
    buyBtn.addEventListener('click', () => once(buyBtn, async () => { try { await add(); location.href = NW.root.replace(/\/$/, '') + '/checkout'; } catch (e) { msg.textContent = e.message; } }));

    /* sticky add to cart (mobile) */
    const sticky = $('[data-sticky]', root);
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => { sticky.hidden = e.isIntersecting || e.boundingClientRect.top > 0; }).observe($('.cta', form));
      $('[data-sticky-buy]', sticky).addEventListener('click', () => { const b = variant() && variant().available ? buyBtn : null; if (b) b.click(); else $('.pl__info', root).scrollIntoView({ behavior: 'smooth' }); });
    }
    const _upd = update;
    update = function () { _upd(); if (sticky) { const v = variant(); $('[data-sticky-price]', sticky).textContent = v ? money(Math.round(v.price * state.qty * (1 - offFor(state.qty) / 100))) : ''; } };

    /* default selection */
    const firstAvail = product.variants.find(v => v.available) || product.variants[0];
    if (firstAvail) { state.color = firstAvail.option1; state.size = firstAvail.option2; }
    update();

    /* calculator */
    const modal = $('[data-calc]', root);
    if (modal) {
      const sizesBox = $('[data-calc-sizes]', modal), res = $('[data-calc-res]', modal), apply = $('[data-calc-apply]', modal);
      const wIn = $('[data-calc-w]', modal), hIn = $('[data-calc-h]', modal);
      let calcSize = null, calcN = 0;
      const dims = s => { const m = String(s).match(/(\d+(?:[.,]\d+)?)\s*[×x]\s*(\d+(?:[.,]\d+)?)/i); return m ? [parseFloat(m[1].replace(',', '.')), parseFloat(m[2].replace(',', '.'))] : null; };
      function drawSizes() {
        const refColor = state.color || product.variants[0].option1;
        sizesBox.innerHTML = $$('.sz__b', form).map(b => {
          const v = findVariant(refColor, b.dataset.size), out = !v || !v.available;
          return `<button type="button" class="sz__b${out ? ' is-out' : ''}${b.dataset.size === calcSize ? ' is-active' : ''}" data-cs="${b.dataset.size}"><strong>${b.dataset.size}</strong>${out ? `<span>${NW.t.soldout}</span>` : ''}</button>`;
        }).join('');
      }
      function calc() {
        const w = parseFloat(String(wIn.value).replace(',', '.')), h = parseFloat(String(hIn.value).replace(',', '.'));
        const d = dims(calcSize);
        if (!(w > 0 && h > 0) || !d) { res.textContent = NW.t.fill; apply.disabled = true; apply.textContent = $('[data-calc-apply]', modal).dataset.label || apply.textContent; calcN = 0; return; }
        const [len, wid] = d; // cm
        const cols = Math.ceil((w * 1.10) / (wid / 100));
        const rows = Math.ceil(h / (len / 100));
        calcN = Math.max(1, cols * rows);
        res.innerHTML = NW.t.result.replace('[n]', `<strong>${calcN}</strong>`).replace('[size]', calcSize).replace('[area]', (w * h).toFixed(2));
        apply.disabled = false;
        apply.textContent = NW.t.add_n.replace('[n]', calcN);
      }
      apply.dataset.label = apply.textContent;
      $$('[data-open-calc]', root).forEach(b => b.addEventListener('click', () => { calcSize = state.size; drawSizes(); calc(); modal.hidden = false; wIn.focus(); }));
      modal.addEventListener('click', e => {
        if (e.target === modal || e.target.closest('[data-close-calc]')) modal.hidden = true;
        const s = e.target.closest('[data-cs]');
        if (s && !s.classList.contains('is-out')) { calcSize = s.dataset.cs; drawSizes(); calc(); }
      });
      [wIn, hIn].forEach(i => i.addEventListener('input', calc));
      apply.addEventListener('click', () => { if (!calcN) return; state.size = calcSize; state.qty = calcN; update(); modal.hidden = true; });
    }
  });

  renderCart().catch(() => {});
})();
